<template>
    <div class="accept-address">
        <div class="layout-box">
            <van-row>
                <van-col class="line-bottom" span="24">
                    <cus-field placeholder="姓名" v-model="form.name"></cus-field>
                </van-col>
                <van-col class="line-bottom" span="24">
                    <cus-field placeholder="电话" v-model="form.concatPhone" type="number"></cus-field>
                </van-col>
                <van-col class="line-bottom" span="24">

                    <!--省市选择-->
                    <div class="city-btn"
                         @click="handleCityClick"
                         :class="{'city-btn__placeholder': !(form.provinceName && form.cityName)}">
                        {{(form.provinceName && form.cityName) ? (form.provinceName + ' ' + form.cityName + ' ' +
                        form.districtName) : '省市区'}}
                    </div>
                    <city-picker v-model="city" :visible.sync="cityShow" show-hot></city-picker>
                </van-col>
                <van-col class="line-bottom" span="24">
                    <cus-field placeholder="详细地址" v-model="form.address">
                    </cus-field>
                </van-col>
                <van-col class="line-bottom" span="24">
                    <div class="resolution_block">
                        <textarea class="resolution_textarea" placeholder="粘贴或输入整段地址，点击“识别”自动拆分姓名、电话地址。" rows="5"
                                  v-model="address"></textarea>
                        <van-button class="resolution_clear_btn" type="warning" @click="handleResolutionClear">清空
                        </van-button>
                        <van-button class="resolution_btn" type="warning" @click="handleResolution">识别</van-button>
                    </div>
                </van-col>
                <van-col class="line-bottom" span="12">
                    <div class="set-default" :class="{'set-default__active': form.addressDefault === '1'}"
                         style="font-size: 0.32rem"
                         @click="form.addressDefault = form.addressDefault === '1' ? '0' : '1'">设为默认收件地址
                    </div>
                </van-col>
                <van-col class="line-bottom" span="12">
                    <div class="clear_information" @click="handleClear">
                        <van-icon name="delete" color="#feb165" size="0.53rem" style="position: absolute"/>
                        <span style="margin-left: 1rem">清空信息</span>
                    </div>
                </van-col>
            </van-row>
        </div>
        <van-list
                class="address-list__box body-padding accept_address-list"
                v-model="loading"
                :finished="finished"
                @load="getList"
                :error.sync="error"
                error-text="请求失败，点击重新加载">
            <van-cell v-for="(item,index) in list" :key="index" @click="handleClick(item)">
                <div>
                    <span> {{item.name}}</span>
                    <span style="float: right"> {{item.concatPhone}}</span>
                </div>
                <div>
                    {{item.provinceName}} {{item.cityName}} {{item.districtName}} {{item.address}}
                </div>
            </van-cell>
        </van-list>
        <div class="layout-box submit-box">
            <div class="submit-box__bg" style="background-color: transparent">
                <van-button class="submit-btn" type="warning" @click="submit">保存</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {Toast} from "vant"
    import {mapState} from 'vuex'
    import axios from "axios";

    export default {
        name: "acceptAddress",
        data() {
            return {
                regionShow: false,
                cityShow: false,
                list: [],
                loading: false,
                finished: false,
                error: false,
                city: {
                    provinceName: '',
                    provinceId: '',
                    cityName: '',
                    cityId: '',
                    districtName: '',
                    districtId: '',
                    address: ''
                },
                params: {
                    params: {
                        addressType: 2,
                        query: ''
                    },
                    page: {
                        pageNum: 1,
                        pageSize: 10
                    }
                },
                splitText: '',
                index: 0,
                address: '',
                // 地址信息
                form: {
                    id: "",
                    name: "",
                    concatPhone: "",
                    provinceName: "",
                    provinceId: "",
                    cityName: "",
                    cityId: "",
                    districtName: "",
                    districtId: "",
                    address: "",
                    clothingCityName: "",
                    clothingCityId: "",
                    lat: 0,
                    lng: 0,
                    deliverer: "",
                    idCardNumber: "",
                    area: "",
                    areaId: "",
                    addressDefault: 0,
                    type: 2
                },
            }
        },
        watch: {
            city: {
                handler(newVal) {
                    this.form.provinceId = newVal.provinceId
                    this.form.provinceName = newVal.provinceName
                    this.form.cityId = newVal.cityId
                    this.form.cityName = newVal.cityName
                    this.form.districtId = newVal.districtId
                    this.form.districtName = newVal.districtName === '不填' ? '' : newVal.districtName
                    this.form.address = newVal.address ? newVal.address : this.form.address
                },
                deep: true
            }
        },
        computed: {
            ...mapState({
                check: state => state.acceptList
            })
        },
        components: {
            regionSelect: () => import('./components/RegionSelector'),
            cityPicker: () => import('./components/CityPicker'),
        },
        methods: {
            handleCityClick() {
                document.querySelector('body').scrollTop = 0
                this.cityShow = true
            },
            //获取地址信息
            getAddress() {
                if (this.$route.params.type === 'add') return
                let params = {params: this.$route.params.id}
                this.$toast.loading({
                    message: '加载中...',
                    duration: 0,
                    mask: true
                })
                this.$axios.post("merchantConcat/getAddress", params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        this.city.provinceId = data.provinceId
                        this.city.provinceName = data.provinceName
                        this.city.cityId = data.cityId
                        this.city.cityName = data.cityName
                        this.city.districtId = data.districtId
                        this.city.districtName = data.districtName
                        Object.keys(this.form).forEach(key => {
                            this.form[key] = data[key]
                        })
                        let checkLists = this.$store.state.acceptLists
                        checkLists.forEach((item, index) => {
                            if (item.id === this.form.id) {
                                this.index = index
                            }
                        })
                    }
                }).finally(()=>{
                    this.$toast.clear()
                })
            },
            handleResolutionClear() {
                this.address = ''
            },
            // 地址识别
            handleResolution() {
                if (!this.address) {
                    Toast({
                        message: "请输入需要解析地址",
                        duration: 2000
                    })
                    return
                }
                let params = {
                    params: {
                        content: this.address
                    }
                }
                this.$toast.loading({
                    message: '解析中...',
                    duration: 0,
                    mask: true
                })
                this.$axios.post("/address/resolution", params).then(res => {
                    let data = res.data.data
                    this.form.provinceId = data.provinceId
                    this.form.provinceName = data.provinceName
                    this.form.cityId = data.cityId
                    this.form.cityName = data.cityName
                    this.form.districtId = data.countryId
                    this.form.districtName = data.countryName
                    this.form.concatPhone = data.phone
                    this.form.address = data.address
                    this.form.name = data.name

                    this.city.provinceId = data.provinceId
                    this.city.provinceName = data.provinceName
                    this.city.cityId = data.cityId
                    this.city.cityName = data.cityName
                    this.city.districtId = data.countryId
                    this.city.districtName = data.countryName
                }).catch(err => {
                    Toast({
                        message: "解析地址失败，请稍后重试",
                        duration: 2000
                    })
                }).finally(() => {
                    this.$toast.clear()
                })
            },
            //保存
            submit() {
                if (this.form.name === '') {
                    Toast({
                        message: "请输入姓名",
                        duration: 2000
                    })
                    return
                }
                if (this.form.concatPhone === '') {
                    Toast({
                        message: "请输入电话",
                        duration: 2000
                    })
                    return
                }
                let telReg1 = !!this.form.concatPhone.match(
                    /^(0|86|17951)?(13[0-9]|15[012356789]|166|165|19[012356789]|17[01235678]|18[0-9]|14[57])[0-9]{8}$/
                );
                let telReg2 = !!this.form.concatPhone.match(
                    /^(0[0-9]{2,3})([2-9][0-9]{6,7})+(-[0-9]{1,4})?$/
                );
                if (!telReg1 && !telReg2) {
                    Toast({
                        message: "请输入正确的电话",
                        duration: 2000
                    })
                    return
                }
                if (this.form.address === '') {
                    Toast({
                        message: "请输入详细地址",
                        duration: 2000
                    })
                    return
                }
                this.$toast.loading({
                    message: '加载中...',
                    duration: 0,
                    mask: true
                })
                if (this.$route.params.type === 'add' && this.form.id === '') { //新增
                    let params = {params: this.form}
                    let path = this.$store.state.toPath
                    this.$axios.post("merchantConcat/addAddress", params).then(res => {
                        let item = this.form
                        item.id = res.data.data
                        if (path === 'preOrder') {
                            Toast({
                                message: "保存成功",
                                duration: 500,
                                onClose: () => {
                                    this.$store.commit('confirmAccept', [item])
                                    this.$router.go(-1)
                                }
                            })
                        } else if (path === 'batchSentItem') {
                            Toast({
                                message: "保存成功",
                                duration: 500,
                                onClose: () => {
                                    this.$store.commit('confirmAccepts', [item])
                                    this.$router.go(-1)
                                }
                            })
                        } else {
                            Toast({
                                message: "保存成功",
                                duration: 2000,
                                onClose: () => {
                                    this.$router.go(-1)
                                }
                            })
                        }
                    }).catch(err => {
                        this.$toast({
                            message: err.data.msg,
                            duration: 1000
                        })
                    })
                } else {//修改
                    let params = {params: this.form}
                    this.$axios.post("merchantConcat/modifyAddress", params).then(res => {
                        let checkList = this.$store.state.acceptList
                        let checkLists = this.$store.state.acceptLists
                        let item = this.form
                        let path = this.$store.state.toPath
                        if (path === 'batchSentItem' && checkLists.length === 1) {
                            Toast({
                                message: "保存成功",
                                duration: 2000,
                                onClose: () => {
                                    this.$store.commit('confirmAccepts', [item])
                                    this.$router.go(-1)
                                }
                            })
                            return
                        } else if (path === 'preOrder') {
                            Toast({
                                message: "保存成功",
                                duration: 2000,
                                onClose: () => {
                                    this.$store.commit('confirmAccept', [item])
                                    this.$router.go(-1)
                                }
                            })
                            return
                        } else if (path === 'batchSentItem' && checkLists.length > 1) {
                            checkLists.forEach((item, index) => {
                                if (this.index === index) {
                                    checkLists[index] = this.form
                                }
                            })
                            Toast({
                                message: "保存成功",
                                duration: 2000,
                                onClose: () => {
                                    this.$store.commit('confirmAccepts', checkLists)
                                    this.$router.go(-1)
                                }
                            })
                            return
                        } else if (path === 'batchSentItem') {
                            Toast({
                                message: "保存成功",
                                duration: 2000,
                                onClose: () => {
                                    this.$store.commit('confirmAccepts', [item])
                                    this.$router.go(-1)
                                }
                            })
                            return
                        }
                        Toast({
                            message: "保存成功",
                            duration: 2000,
                            onClose: () => {
                                this.$router.go(-1)
                            }
                        })
                    }).catch(err => {
                        this.$toast({
                            message: err.data.msg,
                            duration: 1000
                        })
                    })
                }
            },
            handleClear() {
                this.form = {
                    id: "",
                    name: "",
                    concatPhone: "",
                    provinceName: "",
                    provinceId: "",
                    cityName: "",
                    cityId: "",
                    districtName: "",
                    districtId: "",
                    address: "",
                    clothingCityName: "",
                    clothingCityId: "",
                    lat: 0,
                    lng: 0,
                    deliverer: "",
                    idCardNumber: "",
                    area: "",
                    areaId: "",
                    addressDefault: 0,
                    type: 2
                }
                this.address = ''
            },
            getList() {
                this.$axios.post('merchant/getPageAddressByType', this.params).then(res => {
                    let data = res.data.data;
                    if (!Array.isArray(data.list)) {
                        this.finished = true;
                        return
                    }
                    let checkList = JSON.parse(JSON.stringify(this.check))
                    if (checkList.length !== 0) {
                        checkList.forEach((checkItem, checkI) => {
                            checkItem.check = true
                            data.list.forEach((item, i) => {
                                if (checkItem.id === item.id) {
                                    item.check = true
                                    checkList[checkI] = Object.assign({}, checkItem, item)
                                    data.list.splice(i, 1)
                                }
                            })
                            this.list.forEach((item, i) => {
                                if (checkItem.id === item.id) {
                                    this.list.splice(i, 1)
                                }
                            })
                        })
                    }
                    this.list = JSON.parse(JSON.stringify([...checkList, ...this.list, ...data.list]))
                    this.params.page.pageNum++
                    this.finished = !data.hasNextPage
                }).catch(err => {
                    this.error = true
                }).finally(() => {
                    this.loading = false
                })
            },
            handleClick(item) {
                let checkLists = this.$store.state.acceptLists
                for (let i = 0; i < checkLists.length; i++) {
                    if (checkLists[i].id === item.id) {
                        Toast({
                            message: "该收件人已存在，不能在选择",
                        })
                        return
                    }
                }

                Object.keys(this.form).forEach(key => {
                    this.form[key] = item[key]
                })
            }
        },
        mounted() {
            this.getAddress()
        }
    }
</script>

<style lang="scss">
    .accept-address {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;

        .accept_address-list {
            height: calc(100% - 8.5rem);
            overflow: auto;
            padding: 0;
            margin-top: 0.1rem;
        }

        .city-btn {
            font-size: 0.41rem;
            padding: 0.45rem 0.31rem;
            background-color: #fff;
            color: #000;

            &__placeholder {
                color: #747474;
            }
        }

        .submit-box {
            text-align: center;
            position: relative;
            background-color: #e5e5e5;
            height: 0;

            &__bg {
                position: fixed;
                bottom: 0;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: #fff;
                margin-top: 0.13rem;


                .submit-btn {
                    height: 1.07rem;
                    width: 100%;
                    /*margin: 0.56rem 0 1.2rem;*/
                }
            }
        }

        .set-default {
            font-size: 0.32rem;
            color: #8f8f8f;
            position: relative;
            margin: 0.55rem 0.9rem;
            height: 0.43rem;

            &:before {
                content: '';
                background: url('../../assets/btn-unChecked.png') center/100% no-repeat;
                display: flex;
                width: 0.33rem;
                height: 0.33rem;
                position: absolute;
                left: -0.43rem;
                top: 50%;
                transform: translateY(-50%);
            }

            &__active {
                &:before {
                    content: '';
                    background: url('../../assets/btn-checked.png') center/100% no-repeat;
                    display: flex;
                    width: 0.33rem;
                    height: 0.33rem;
                    position: absolute;
                    left: -0.43rem;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }

        .clear_information {
            margin: 0.55rem 0.9rem;
            height: 0.43rem;
            color: #8f8f8f;
        }

        .resolution_block {
            width: 100%;
            padding: 5px;
            box-sizing: border-box;
            position: relative;

            .resolution_textarea {
                border: 1px solid #e5e5e5;
                width: 100%;
                padding-left: 5px;
                padding-right: 0;
                box-sizing: border-box;
                font-size: 13px;
                resize: none;
            }

            .resolution_btn {
                position: absolute;
                width: 1.2rem;
                right: 0.4rem;
                bottom: 0.4rem;
                line-height: 0.6rem;
                height: 0.6rem;
                border: 1px solid #FE9329;
                box-sizing: border-box;
                border-radius: 0.1rem;
                font-size: 12px;
                padding: 0;
            }

            .resolution_clear_btn {
                position: absolute;
                width: 1.2rem;
                right: 2rem;
                bottom: 0.4rem;
                line-height: 0.6rem;
                height: 0.6rem;
                border: 1px solid #FE9329;
                background-color: #fff;
                color: #FE9329;
                box-sizing: border-box;
                border-radius: 0.1rem;
                font-size: 12px;
                padding: 0;
            }
        }
    }


</style>
